var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 23.5C6.95 23.5 6.47917 23.3042 6.0875 22.9125C5.69583 22.5208 5.5 22.05 5.5 21.5V3.5C5.5 2.95 5.69583 2.47917 6.0875 2.0875C6.47917 1.69583 6.95 1.5 7.5 1.5H17.5C18.05 1.5 18.5208 1.69583 18.9125 2.0875C19.3042 2.47917 19.5 2.95 19.5 3.5V21.5C19.5 22.05 19.3042 22.5208 18.9125 22.9125C18.5208 23.3042 18.05 23.5 17.5 23.5H7.5ZM7.5 18.5V21.5H17.5V18.5H7.5ZM12.5 21C12.7833 21 13.0208 20.9042 13.2125 20.7125C13.4042 20.5208 13.5 20.2833 13.5 20C13.5 19.7167 13.4042 19.4792 13.2125 19.2875C13.0208 19.0958 12.7833 19 12.5 19C12.2167 19 11.9792 19.0958 11.7875 19.2875C11.5958 19.4792 11.5 19.7167 11.5 20C11.5 20.2833 11.5958 20.5208 11.7875 20.7125C11.9792 20.9042 12.2167 21 12.5 21ZM7.5 16.5H17.5V6.5H7.5V16.5ZM7.5 4.5H17.5V3.5H7.5V4.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.2e95b5b55d231945fb1940b33e4747f1.svg";
export { ForwardRef as ReactComponent };